import { api } from './client'

// Jobs: a piece of work for a customer that quotes, invoices, bills and
// expenses can belong to (/api/sales/jobs).

export const listJobs = async (params = {}) => (await api.get('/sales/jobs', { params })).data
export const getJob = async (jobId) => (await api.get(`/sales/jobs/${jobId}`)).data
export const saveJob = async (payload) => (payload.job_id
  ? (await api.put(`/sales/jobs/${payload.job_id}`, payload)).data
  : (await api.post('/sales/jobs', payload)).data)
/** Open jobs for a picker; include keeps the one already chosen. */
export const jobChoices = async ({ customerId, include } = {}) => (await api.get('/sales/jobs/choices', {
  params: { ...(customerId ? { customer_id: customerId } : {}), ...(include ? { include } : {}) },
})).data
/** Paid deposits on a job and what's left to take off (leaving invoiceId's own out). */
export const jobDeposits = async (jobId, invoiceId) => (await api.get(`/sales/jobs/${jobId}/deposits`, { params: invoiceId ? { invoice_id: invoiceId } : {} })).data
/** A draft deposit invoice for a job; returns { invoice_id }. */
export const requestDeposit = async (jobId, amount) => (await api.post(`/sales/jobs/${jobId}/deposit`, { amount })).data
/** A draft invoice releasing retainage held on a job ({ amount } or all that's left); returns { invoice_id }. */
export const releaseRetainage = async (jobId, amount) => (await api.post(`/sales/jobs/${jobId}/retainage-release`, amount ? { amount } : {})).data
/** A draft stage invoice for a share of a quote: { percent } or { rest: true }; returns { invoice_id }. */
export const billQuoteStage = async (quoteId, body) => (await api.post(`/sales/customer-quotes/${quoteId}/progress`, body)).data

// Change orders: agreed changes to a job's work and price after the quote.
export const saveChange = async (jobId, payload) => (payload.change_id
  ? (await api.put(`/sales/jobs/${jobId}/changes/${payload.change_id}`, payload)).data
  : (await api.post(`/sales/jobs/${jobId}/changes`, payload)).data)
/** { status: Approved|Declined|Waiting, approved_date?, approved_by? } */
export const setChangeStatus = async (jobId, changeId, body) => (await api.post(`/sales/jobs/${jobId}/changes/${changeId}/status`, body)).data
export const deleteChange = async (jobId, changeId) => (await api.delete(`/sales/jobs/${jobId}/changes/${changeId}`)).data
/** A draft invoice for an approved change; returns { invoice_id }. */
export const billChange = async (jobId, changeId) => (await api.post(`/sales/jobs/${jobId}/changes/${changeId}/bill`)).data

// Photos on a job (part of Jobs): served only through the API.
export const listJobPhotos = async (jobId) => (await api.get(`/sales/jobs/${jobId}/photos`)).data
export const addJobPhotos = async (jobId, files, caption = '') => {
  const form = new FormData()
  files.forEach((f) => form.append('file', f))
  if (caption) form.append('caption', caption)
  return (await api.post(`/sales/jobs/${jobId}/photos`, form, { headers: { 'Content-Type': 'multipart/form-data' } })).data
}
export const captionJobPhoto = async (photoId, caption) => (await api.put(`/sales/jobs/photos/${photoId}`, { caption })).data
export const deleteJobPhoto = async (photoId) => (await api.delete(`/sales/jobs/photos/${photoId}`)).data
export const jobPhotoUrl = (photoId, { download = false } = {}) => `/api/sales/jobs/photos/${photoId}${download ? '?download=1' : ''}`

// Customer measurements for made-to-order work (part of Jobs).
export const listMeasurements = async (customerId) => (await api.get('/sales/jobs/measurements', { params: { customer_id: customerId } })).data
export const saveMeasurement = async (payload) => (payload.measurement_id
  ? (await api.put(`/sales/jobs/measurements/${payload.measurement_id}`, payload)).data
  : (await api.post('/sales/jobs/measurements', payload)).data)
export const deleteMeasurement = async (id) => (await api.delete(`/sales/jobs/measurements/${id}`)).data
// The sets a job is made to: each for a garment or a person, from any customer.
export const listJobMeasurements = async (jobId) => (await api.get(`/sales/jobs/${jobId}/measurements`)).data
export const saveJobMeasurement = async (jobId, { link_id, ...body }) => (link_id
  ? (await api.put(`/sales/jobs/${jobId}/measurements/${link_id}`, body)).data
  : (await api.post(`/sales/jobs/${jobId}/measurements`, body)).data)
export const removeJobMeasurement = async (jobId, linkId) => (await api.delete(`/sales/jobs/${jobId}/measurements/${linkId}`)).data
